export default __webpack_public_path__ + "static/media/error_outline.a85971da.svg";